





























































export default {
	name: 'detalleAutorizacion',
	inject: ['responsive'],
	props: {
		visible: {
			type: Boolean,
			required: true,
			default: false,
		},
		recordSelected: {
			type: Object,
		},
		tableGranos: {
			type: Array,
		},
	},
	data() {
		return {
			show: false,
			autorizando: false,
		};
	},
	computed: {},
	watch: {
		visible(v) {
			this.show = !this.show;
		},
	},
	filters: {
		capitalize: function (value) {
			if (!value) return '';
			value = value.toString();
			return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
		},
		numeric: function (value) {
			return new Intl.NumberFormat('de-DE').format(value);
		},
	},
	methods: {
		handlePrint(): void {
			this.imprimiendo = true;
			let url = `./api/public/proxy/files?codcom=${this.recordSelected.codcom}&codtal=${this.recordSelected.codtal}&numero=${this.recordSelected.numero}&cooperativa=${this.$store.state.config.cuit}&type=pdf`;
			window.open(url);
			this.imprimiendo = false;
		},
		handleClick(bool): void {
			let msg = bool
				? 'Está por autorizar el comprobante.Ingrese un detalle de la autorización'
				: 'Está por rechazar el comprobante. Ingrese un detalle del rechazo';
			let msgButton = bool ? ' Autorizar' : 'Rechazar';
			this.$prompt(msg, 'Atención', {
				confirmButtonText: msgButton,
				cancelButtonText: 'Cancelar',
				type: 'warning',
				center: this.responsive.isMobile,
				customClass: this.responsive.isMobile ? 'confirm-mobile' : '',
			})
				.then(({ value }) => {
					this.autorizando = true;
					let param = {
						codcom: this.recordSelected.codcom,
						codtal: this.recordSelected.codtal,
						numero: this.recordSelected.numero,
						autoriza: bool,
						detalle: value,
					};
					this.$store
						.dispatch('putAutorizar', param)
						.then(response => {
							if (response.data.success) {
								this.$message({
									message: response.data.msg ? response.data.msg : 'Success',
									type: 'success',
									showClose: true,
									duration: 0,
								});
								this.show = false;
								this.$emit('callAutorizacion', true);
							} else {
								this.$message({
									message: response.data.msg ? response.data.msg : 'Error',
									showClose: true,
									type: 'error',
									duration: 0,
								});
							}
							this.autorizando = false;
						})
						.catch(() => {
							this.autorizando = false;
							this.$message({
								type: 'error',
								message: 'No se puedo realizar la operanción',
							});
						});
				})
				.catch(() => {
					this.autorizando = false;
					this.$message({
						type: 'info',
						message: 'Operación cancelada',
					});
				});
		},
	},
	mounted() {},
};
